import { Skeleton } from '@mui/material';

export const SkeletonFilters = () => {
  return (
    <>
      <div className='d-flex'>
        <Skeleton
          variant='rectangular'
          sx={{
            bgcolor: 'grey.900',
            width: '25%',
            borderRadius: '.4rem',
            height: 38,
          }}
        />
        <Skeleton
          variant='rectangular'
          sx={{
            bgcolor: 'grey.900',
            width: '25%',
            borderRadius: '.4rem',
            height: 38,
            margin: '0 .25rem',
          }}
        />
        <Skeleton
          variant='rectangular'
          sx={{
            bgcolor: 'grey.900',
            width: '25%',
            borderRadius: '.25rem',
            marginRight: '.25rem',

            height: 38,
          }}
        />
        <Skeleton
          variant='rectangular'
          sx={{
            bgcolor: 'grey.900',
            width: '25%',
            borderRadius: '.4rem',
            height: 38,
          }}
        />
      </div>
    </>
  );
};

export const SkeletonVenueList = () => {
  return (
    <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 180,
        }}
      />
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 180,
        }}
      />
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 180,
          marginTop: '1.5rem',
        }}
      />
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 180,
          marginTop: '1.5rem',
        }}
      />
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 180,
          marginTop: '1.5rem',
        }}
      />
      <Skeleton
        variant='rectangular'
        sx={{
          bgcolor: 'grey.900',
          width: '100%',
          borderRadius: '.4rem',
          height: 180,
          marginTop: '1.5rem',
        }}
      />
    </div>
  );
};
